"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseString = exports.parseFile = exports.parseStream = exports.parse = exports.ParserOptions = exports.CsvParserStream = void 0;
const fs = __importStar(require("fs"));
const stream_1 = require("stream");
const ParserOptions_1 = require("./ParserOptions");
const CsvParserStream_1 = require("./CsvParserStream");
__exportStar(require("./types"), exports);
var CsvParserStream_2 = require("./CsvParserStream");
Object.defineProperty(exports, "CsvParserStream", {
  enumerable: true,
  get: function () {
    return CsvParserStream_2.CsvParserStream;
  }
});
var ParserOptions_2 = require("./ParserOptions");
Object.defineProperty(exports, "ParserOptions", {
  enumerable: true,
  get: function () {
    return ParserOptions_2.ParserOptions;
  }
});
exports.parse = args => new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(args));
exports.parseStream = (stream, options) => stream.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
exports.parseFile = function (location) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fs.createReadStream(location).pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseString = (string, options) => {
  const rs = new stream_1.Readable();
  rs.push(string);
  rs.push(null);
  return rs.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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